﻿import { mapGetters, mapState } from 'vuex';
import errorMessage from './errorMessage.vue';

export default {
    name: 'ca-order-summary',
    props: ['viewmodel', 'editmode'],
    components: {
        'ca-error-message': errorMessage
    },
    data: () => ({
        showAddedAdditionalProducts: false,
        showCancelledAdditionalProducts: false
    }),
    mounted: function () {
    },
    methods: {
        getQueryString: function (field, url) {
            const href = url ? url : window.location.href;
            const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            const string = reg.exec(href);
            return string ? string[1] : null;
        },
        getOrder: function (orderGuid) {
            this.$store.dispatch('getOrder', {
                'orderGuid': orderGuid,
                'context': 'summary',
                'getOrderLoaderTitle': this.viewmodel.getOrderForSummaryLoaderTitle,
                'getOrderLoaderMessage': this.viewmodel.getOrderForSummaryLoaderMessage
            });
        },
        checkContractsSignature: function (orderId, dealerCode) {
            this.$store.dispatch('checkContractsSignature', { 'orderId': orderId, 'dealerCode': dealerCode, 'userId': this.order.salesAgent });
        },
        getTeliaContracts: function (orderId, dealerCode) {
            this.$store.dispatch('getTeliaContracts', { 'orderId': orderId, 'dealerCode': dealerCode, 'userId': this.order.salesAgent });
        },
        getTFContracts: function (orderId, dealerCode) {
            this.$store.dispatch('getTFContracts', { 'orderId': orderId, 'dealerCode': dealerCode, 'userId': this.order.salesAgent });
        },
        signContracts: function () {
            this.$store.dispatch('signContracts');
        },
        showAddedAdditionalProductsFlag: function () {
            this.showAddedAdditionalProducts = true;
        },
        showCancelledAdditionalProductsFlag: function () {
            this.showCancelledAdditionalProducts = true;
        },
        formatDate: function (d) {
            var date = new Date(d);
            var day = date.getDate();
            var month = date.getMonth() + 1; // getMonth returns number from 0 to 11
            var year = date.getFullYear();

            return day + "." + month + "." + year;
        },
        mapPBSKeyName: function (key) {
            switch (key) {
                case 'BANK':
                    return 'Bank';
                case 'BANK_BRANCH':
                    return 'Reg. number';
                case 'BANK_ACCOUNT_NUMBER':
                    return 'Account number';
                default:
                    return key;
            }
        },
        mapFEEKeyName: function (key) {
            switch (key) {
                case 'ADMIN_FEE':
                    return 'Admin fee';
                case 'ACT_FEE':
                    return 'Activation fee';
                case 'PRO_FEE':
                    return 'Prolong fee';
                case 'TRANSFER_FEE':
                    return 'Transfer fee';
                case 'SIM_SWAP_FEE':
                    return 'Swap sim fee';
                default:
                    return key;
            }
        },
        mapSubscriptioTypeValue: function (value) {
            switch (value) {
                case 'NEW':
                    return 'New subscription';
                case 'CHANGE':
                    return 'Modify existing subscription';
                case 'PORTING':
                    return 'Porting of number';
                case 'FIXED_LINE_PORTING':
                    return 'Fixed line porting';
                case 'LEASE_REMOVAL':
                    return 'Lease removal';
                case 'REACTIVATE':
                    return 'Reactivation';
                case 'MODIFY_CALL_FORWARDING':
                    return 'MODIFY_CALL_FORWARDING';
                default:
                    return value;
            }
        },
        mapEquipmentTypeValue: function (value) {
            switch (value) {
                case 'SIM':
                    return 'SIM';
                case 'HANDSET':
                    return 'Handset';
                case 'LAPTOP':
                    return 'Laptop';
                case 'ACCESSORY':
                    return 'Accessory';
                case 'FEMTO':
                    return 'Femto';
                case 'OTHER':
                    return 'Other';
                case 'TABLET':
                    return 'Tablet';
                case 'MODEM':
                    return 'Modem';
                default:
                    return value;
            }
        },
        mapAgreementTypeValue: function (value) {
            switch (value) {
                case 'PRIVATE.NORLYS':
                    return 'Norlys Family';
                case 'PRIVATE.REGULAR':
                    return 'Norlys Privataftale';
                default:
                    return value;
            }
        },
        hasGivenConsents: function (consents) {
            if (!consents) {
                return false;
            }

            var ret = false;

            consents.forEach((consentItem) => {
                if (consentItem.given === true) {
                    ret = true;
                }
            });

            return ret;
        },
        hasNotGivenConsents: function (consents) {
            if (!consents) {
                return false;
            }

            var ret = false;

            consents.forEach((consentItem) => {
                if (consentItem.given === false) {
                    ret = true;
                }
            });

            return ret;
        },
        areDatesEqualIgnoreTimestamp: function (estimatedPortingDateString, requestedPortingDateString) {
            // This function returns true if firstDateString and secondDateString are equal, timestamps are ignored

            // If at least one of the parameters is empty string, then return false 
            if (estimatedPortingDateString === '' || requestedPortingDateString === '') {
                return false;
            }

            // Create date objects from strings parameters
            var estimatedPortingDateObj = new Date(estimatedPortingDateString);
            var requestedPortingDateObj = new Date(requestedPortingDateString);

            // Check the dates were created sucessfully. If not, then return false
            if (estimatedPortingDateObj == null || requestedPortingDateObj == null) {
                return false;
            }

            // Set the time part of both date objects to zeros (ignore the timestamp)
            estimatedPortingDateObj.setHours(0, 0, 0);
            requestedPortingDateObj.setHours(0, 0, 0);

            // Compare the primitive values of those and return the evaluation
            return estimatedPortingDateObj.valueOf() == requestedPortingDateObj.valueOf();
        }
    },
    created: function () {
        if (!this.editmode) {
            const orderGuid = this.getQueryString('guid');
            this.getOrder(orderGuid);

            this.$store.dispatch('setTexts', {
                'orderState': this.viewmodel.orderStateErrorMessage,
                'getOrder': this.viewmodel.getOrderErrorMessage,
                'contracts': this.viewmodel.teliaContractsErrorMessage,
                'checkSignature': this.viewmodel.checkContractsErrorMessage,
                'hasAnyContract': 'Error while retrieving contract info',
                'hasAnyTeliaContract': 'Error while retrieving Norlys contract info',
                'blockedPopup': this.viewmodel.blockedPopupContractsErrorMessage,
                'submitOrder': this.viewmodel.submitOrderErrorMessage,
                'submitOrderState1': this.viewmodel.submitOrderState1ErrorMessage,
                'submitOrderState2': this.viewmodel.submitOrderState2ErrorMessage,
                'submitOrderForRemoteChannel': this.viewmodel.submitOrderForRemoteChannelErrorMessage
            });

            this.$store.dispatch('setConstants', {
                'returnLabelMaterialIds': this.viewmodel.returnLabelMaterialIds
            });

            this.$store.watch(state => state.creditaccount.inErrorState, (newErrors, oldErrors) => {
                var childNodes = document.getElementById("xwing").getElementsByTagName('*');
                for (var i = 0; i < childNodes.length; i++) {
                    childNodes[i].disabled = true;
                }
            });
        }
    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                isNewTeliaCustomer: state => state.creditaccount.isNewTeliaCustomer,
                showTFSummaryInformation: state => state.creditaccount.showTFSummaryInformation,
                contracts: state => state.creditaccount.contracts,
                creditEvaluation: state => state.creditaccount.creditEvaluation,
                pbsInformation: state => state.creditaccount.pbsInformation,
                paymentMethod: state => state.creditaccount.paymentMethod,
                creditAgreement: state => state.creditaccount.creditAgreement,
                pageLoader: state => state.creditaccount.pageLoader,
                hardwareDelivery: state => state.creditaccount.order.hardwareDelivery

            }),
            mapGetters({
                orderPersonAddressStreet: 'orderPersonAddressStreet',
                orderPersonAddressCity: 'orderPersonAddressCity',
                orderTotalPrice: 'orderTotalPrice',
                currency: 'currency',
                showCreditAgreementDetails: 'showCreditAgreementDetails',
                teliaContracts: 'teliaContracts',
                tfContracts: 'tfContracts',
                hasAnyTeliaContract: 'hasAnyTeliaContract'
            }),
            {
                orderPersonName: function () {
                    if (this.order.orderer)
                        return this.order.orderer.person.name.firstName + " " + this.order.orderer.person.name.lastName;
                    else return "";
                }
            }
        )
}